import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import ILocalState from './stateInterface';

const initState: ILocalState = {
    areOffersLoading: true,
    isProjectLoading: true,
    isLeadLoading: true,
    areNextStepsLoading: true,
};

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations,
};
